import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	operator__set: 'mw/operator/set',
};

export const operatorApi = createApi({
	reducerPath: 'operatorApi',

	endpoints: (builder) => ({
		operatorSet: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/operator/set',
				body,
			}),
			providesTags: [tags.operator__set],
		}),
	}),
});

export const {
	operatorSet,
} = operatorApi.endpoints;

export default operatorApi;